/**
 * 플랫폼 감지 유틸리티
 * React Native WebView 환경에서 네이티브 플랫폼 감지
 */

/**
 * React Native WebView 환경인지 확인
 */
export const isWebViewReady = (): boolean => {
  try {
    return typeof window !== 'undefined' && 
           (window.ReactNativeWebView !== undefined || 
            (window as any).webkit?.messageHandlers !== undefined ||
            (window as any).Android !== undefined)
  } catch {
    return false
  }
}

/**
 * 플랫폼 정보 가져오기
 */
export const getPlatformInfo = () => {
  if (!isWebViewReady()) {
    return {
      platform: 'web',
      isNative: false,
      isIOS: false,
      isAndroid: false,
      isWeb: true,
      ready: false
    }
  }

  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera
  
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream
  const isAndroid = /android/i.test(userAgent)
  
  return {
    platform: isIOS ? 'ios' : isAndroid ? 'android' : 'web',
    isNative: isIOS || isAndroid,
    isIOS,
    isAndroid,
    isWeb: !isIOS && !isAndroid,
    ready: true
  }
}

/**
 * 네이티브 플랫폼인지 확인
 */
export const isNative = (): boolean => {
  if (!isWebViewReady()) {
    return false
  }
  
  const { isNative: native } = getPlatformInfo()
  return native
}

/**
 * iOS 플랫폼인지 확인
 */
export const isIOS = (): boolean => {
  if (!isWebViewReady()) return false
  
  const { isIOS: ios } = getPlatformInfo()
  return ios
}

/**
 * Android 플랫폼인지 확인
 */
export const isAndroid = (): boolean => {
  if (!isWebViewReady()) return false
  
  const { isAndroid: android } = getPlatformInfo()
  return android
}

/**
 * 웹 플랫폼인지 확인
 */
export const isWeb = (): boolean => {
  if (!isWebViewReady()) return true
  
  const { isWeb: web } = getPlatformInfo()
  return web
}
